import { useState, useEffect } from 'react';
import api from '../api';

export default function SettingsAdminPage() {
  const [settings, setSettings] = useState({});
  const [loading, setLoading] = useState(true);
  const [newKey, setNewKey] = useState('');
  const [saving, setSaving] = useState('');

  useEffect(() => {
    api.getSettings().then(setSettings).catch(console.error).finally(() => setLoading(false));
  }, []);

  const save = async (key, value) => {
    setSaving(key);
    try {
      await api.updateSetting(key, value);
      setSettings(prev => ({ ...prev, [key]: value }));
    } catch (err) {
      alert(err.message);
    } finally {
      setSaving('');
    }
  };

  if (loading) return <div className="page-loading">Loading...</div>;

  return (
    <div className="page">
      <div className="page-header">
        <h1>Settings</h1>
      </div>

      <div className="settings-section">
        <h2>Ledger AI</h2>

        <div className="setting-row">
          <div className="setting-info">
            <div className="setting-label">AI Enabled</div>
            <div className="setting-desc">Enable or disable the Ledger AI chat feature for all users</div>
          </div>
          <div className="setting-control">
            <button
              className={`toggle-btn ${settings.ai_enabled !== 'false' ? 'on' : 'off'}`}
              onClick={() => save('ai_enabled', settings.ai_enabled === 'false' ? 'true' : 'false')}
              disabled={saving === 'ai_enabled'}
            >
              {settings.ai_enabled !== 'false' ? 'ON' : 'OFF'}
            </button>
          </div>
        </div>

        <div className="setting-row">
          <div className="setting-info">
            <div className="setting-label">API Key</div>
            <div className="setting-desc">Anthropic API key for Claude. Current: {settings.ai_api_key || 'Not set (using .env fallback)'}</div>
          </div>
          <div className="setting-control">
            <input
              type="password"
              placeholder="sk-ant-..."
              value={newKey}
              onChange={e => setNewKey(e.target.value)}
              className="setting-input"
            />
            <button
              className="btn btn-primary btn-sm"
              onClick={() => { save('ai_api_key', newKey); setNewKey(''); }}
              disabled={!newKey || saving === 'ai_api_key'}
            >
              Save Key
            </button>
          </div>
        </div>

        <div className="setting-row">
          <div className="setting-info">
            <div className="setting-label">AI Model</div>
            <div className="setting-desc">Which Claude model to use for Ledger AI queries</div>
          </div>
          <div className="setting-control">
            <select
              value={settings.ai_model || 'claude-sonnet-4-6'}
              onChange={e => save('ai_model', e.target.value)}
              className="setting-select"
              disabled={saving === 'ai_model'}
            >
              <option value="claude-sonnet-4-6">Claude Sonnet 4.6 (recommended)</option>
              <option value="claude-haiku-4-5-20251001">Claude Haiku 4.5 (faster, cheaper)</option>
              <option value="claude-opus-4-6">Claude Opus 4.6 (most capable)</option>
            </select>
          </div>
        </div>
      </div>
    </div>
  );
}
